import value from '../runtime/runtime.js';
export default value;
